import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { themed } from '@atlaskit/theme/components';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlaskit/theme/constants';
import { components } from '@atlaskit/select';
import styled, { css } from 'styled-components';
import { N200, DN90 } from '@atlaskit/theme/colors';
var spacing = gridSize();
var fontSize = 12;
var innerHeight = spacing * 2; // 16px

var lineHeight = innerHeight / fontSize;
var ControlWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0px ", "px ", "px;\n"])), spacing, spacing);
var getColor = themed({
  light: token('color.text.lowEmphasis', N200),
  dark: token('color.text.lowEmphasis', DN90)
});

var getPadding = function getPadding() {
  var right = 0;
  var bottom = spacing / 2;
  var left = 0;
  var top = spacing * 2.5;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", "px ", "px ", "px ", "px;\n  "])), top, right, bottom, left);
};

var Label = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 600;\n  line-height: ", ";\n  ", "\n"])), function (props) {
  return getColor(props);
}, fontSize, lineHeight, getPadding);
export var PopupControl = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PopupControl, _React$PureComponent);

  var _super = _createSuper(PopupControl);

  function PopupControl() {
    _classCallCheck(this, PopupControl);

    return _super.apply(this, arguments);
  }

  _createClass(PopupControl, [{
    key: "render",
    value: function render() {
      var popupTitle = this.props.selectProps.popupTitle;
      return /*#__PURE__*/React.createElement(ControlWrapper, null, /*#__PURE__*/React.createElement(Label, null, popupTitle), /*#__PURE__*/React.createElement(components.Control, this.props));
    }
  }]);

  return PopupControl;
}(React.PureComponent);